export enum PaymentOperationType {
  Tip = 'tip',
  Subscription = 'subscription',
  PostUnlock = 'post_unlock',
  TrackUnlock = 'track_unlock',
}
